import { MouseEventHandler, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACCOUNT_TYPES, LOG_AF_EVENT_NAMES } from "../../../app/appConstants";
import parseAccountName from "../../../utils/parseAccountName";
import { logAppsflyerAction, setUserSelectedAccountCode } from '../../../app/appActions';
import { getUserSelectedAccountCode, getUserSelectedAccountType } from "../../../app/appSelectors";
import { locationSlice } from '../../../modules/Location/locationReducer';
import { LOCATION_NAMES } from '../../../modules/Location/locationConstants';

const useMobileAccountBoxButtonsHandlers = () => {
    const dispatch = useDispatch();
    const accountCode = useSelector(getUserSelectedAccountCode);
    const accountType = useSelector(getUserSelectedAccountType);

    const handleDepositButtonClick: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.DEPOSIT,
        }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_DEPOSIT,
            payload: { account_type: accountType, source: 'portfolio' },
        }));
    }, [accountType, dispatch]);

    const handleRefillButtonClick: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.REFILL,
        }));
    }, [dispatch]);

    const handleRespawnButtonClick = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.RESPAWN }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_RESPAWN,
            payload: { account_type: accountType },
        }));
    }, [accountType, dispatch]);

    const handleWithdrawButtonClick: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.WITHDRAW }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_WITHDRAW,
            payload: { account_type: accountType, source: 'portfolio' },
        }));
    }, [dispatch, accountType]);

    const handleStartRealButtonClick: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
        e.preventDefault();
        const accountCodeLive = parseAccountName(accountCode).getAccountCode(ACCOUNT_TYPES.LIVE);
        dispatch(setUserSelectedAccountCode(accountCodeLive));
    }, [accountCode, dispatch]);

    const handleHistoryButtonClick: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.HISTORY,
        }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_TRANSACTIONS,
            payload: { account_type: accountType },
        }));
    }, [accountType, dispatch]);


    return {
        handleStartRealButtonClick,
        handleWithdrawButtonClick,
        handleDepositButtonClick,
        handleRefillButtonClick,
        handleRespawnButtonClick,
        handleHistoryButtonClick,
    }
}

export default useMobileAccountBoxButtonsHandlers;
